/**
 * ═══════════════════════════════════════════════════════════════════════════
 * G-45 — the price floor, for LIVE ESTIMATES ONLY
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * **This is a mirror of `src/common/pricing/price-floor.ts`, and the server is
 * the authority.** It exists for one reason: the bouquet builder needs to move
 * its suggested price as the florist adds stems, and a round trip per keystroke
 * is worse than a local estimate.
 *
 * `estimateMinPriceEur` (the cost+VAT floor) USED to live here too and was
 * deleted on 2026-09-10 when the owner reduced the build panel to a single
 * price. The floor itself is untouched — it is computed and enforced on the
 * SERVER at sale time, and the till's pre-sale warning reads the server's
 * figure. Do not re-add a client-side copy just to show a number. The kiosk
 * builder calls this through `builderCostEstimate`
 * (`components/shop-floor/kioskCostDisplay.ts`), which works out no price at
 * all while a line's cost is unknown (WO-B, OD-198).
 *
 * The authoritative figures come back from the server as `priceGuidance` when
 * the build is saved. **Never** use these to decide anything — a below-floor
 * sale is judged server-side, at sale time, against the server's own numbers.
 *
 * If you change a formula here, change it there in the same commit. G-30's
 * hardening pass had to delete a client-side after-VAT figure that had silently
 * drifted from the server's; do not recreate that.
 */

/**
 * The gross price leaving `targetMarginPercent` of the NET price as margin.
 * Margin-on-net-price, NOT markup-on-cost — see the server module.
 *
 * Returns `null` rather than Infinity when the margin is out of range, so a bad
 * category setting shows as "—" instead of a nonsense number.
 */
export function estimateTargetPriceEur(
  cogsEur: number,
  vatRatePercent: number,
  targetMarginPercent: number,
): number | null {
  if (!Number.isFinite(targetMarginPercent) || targetMarginPercent < 0 || targetMarginPercent >= 100) {
    return null;
  }
  return (cogsEur / (1 - targetMarginPercent / 100)) * (1 + vatRatePercent / 100);
}
